export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

// Helper function to format date to YYYY-MM-DD
export const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString().split('T')[0]; // Returns the date in YYYY-MM-DD format
};

export const formatDateTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString(); // Returns the date in YYYY-MM-DD format
};

export function formatNumber(num) {
    if (num === null || num === undefined || num === "") return "";

    const n = Number(num);
    if (isNaN(n)) return num;

    const abs = Math.abs(n);

    if (abs >= 1_000_000_000_000) return (n / 1_000_000_000_000).toFixed(1) + "T";
    if (abs >= 1_000_000_000) return (n / 1_000_000_000).toFixed(1) + "B";
    if (abs >= 1_000_000) return (n / 1_000_000).toFixed(1) + "M";
    if (abs >= 10_000) return (n / 1_000).toFixed(1) + "K";

    return n.toLocaleString();
}